import * as types from "../actions/types";

const initialState = {
    list: null,
    item: null
};


export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_STYLES_COMPLETED:
            return Object.assign({}, state, {
                list: action.payload
            });
        case types.GET_STYLE_COMPLETED:
            return Object.assign({}, state, {
                item: action.payload
            });
        case types.CLEAR_STYLE:
            return Object.assign({}, state, {
                item: null
            });

        default:
            return state;
    }
};
